import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subject-management',
  templateUrl: './subject-management.component.html',
  styleUrls: ['./subject-management.component.css']
})
export class SubjectManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
